import { createSlice } from "@reduxjs/toolkit";
import { fetchProfile, editUser } from "./thunk";

const initialState = {
  error: "",
  success: "",
  user: {},
  loading: false,
};

const ProfileSlice = createSlice({
  name: "Profile",
  initialState,
  reducers: {
    resetProfileFlag(state) {
      state.success = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Profile Cases
      .addCase(fetchProfile.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.success = "";
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.loading = false;
        // Extract user from response.data.user
        state.user = action.payload.data?.user || action.payload.data || {};
        state.success = action.payload.message || "Profile fetched successfully!";
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Edit User Cases
      .addCase(editUser.pending, (state) => {
        state.success = "";
        state.error = "";
      })
      .addCase(editUser.fulfilled, (state, action) => {
        state.success = action.payload.message || "Profile updated successfully";
        // Update user data if returned in response
        if (action.payload.data && action.payload.data.user) {
          state.user = action.payload.data.user;
        } else if (action.payload.data) {
          state.user = { ...state.user, ...action.payload.data };
        }
      })
      .addCase(editUser.rejected, (state, action) => {
        state.error = action.payload || "Failed to update profile";
      });
  },
});

export const { resetProfileFlag } = ProfileSlice.actions;
export default ProfileSlice.reducer;
